/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import Kpi from "../../components/KPI/Kpi";
import KpiCardOverview from "../../components/KpiCardOverview/KpiCardOverview";
import styled from "styled-components";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function OverviewMobile({ app, config }) {
  const [scorePercentageNum, setScorePercentageNum] = useState(0);
  const [scorePercentageColor, setScorePercentageColor] = useState("#38BC9A");

  const { selections } = useSelections();
  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [score, totalScore, scorePercentage] = [
    Kpi({
      app,
      objectId: "kvsLs",
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: "hhqJDa",
      updatesWithSelection: true,
    }),
    Kpi({
      app,
      objectId: "MFYzdU",
      updatesWithSelection: true,
    }),
  ];

  const getColorFromPercentage = (percentage) => {
    switch (true) {
      case percentage < 85:
        return "#E95248";
      case percentage < 100:
        return "#FDB949";
      default:
        return "#38BC9A";
    }
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Distribuidor")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  useEffect(() => {
    const num = scorePercentage ? scorePercentage.slice(0, -1) * 1 : 0;
    setScorePercentageNum(num > 100 ? 100 : num);
  }, [scorePercentage]);

  useEffect(() => {
    setScorePercentageColor(getColorFromPercentage(scorePercentageNum));
  }, [scorePercentageNum]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid container rowGap={2} marginTop={"29px"}>
            <Grid item width={"100%"}>
              <LayoutCardWrapper className={"container-table"}>
                <Card
                  app={app}
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <div className="contianerKPis">
                    <div className="kpaiCardFase">
                      <div className="columnLeft">
                        <p className="title">% afastamento</p>
                        <p className="day-total">
                          dias totais:
                          <span>
                            <NativeObject
                              app={app}
                              key="nmpCyyd"
                              reference={{ id: "nmpCyyd" }}
                              style={{
                                width: "29px",
                                height: "15px",
                              }}
                            />
                          </span>
                        </p>
                        <p className="day-trans">
                          Dias transc.:
                          <span>
                            <NativeObject
                              app={app}
                              key="jJHjSn"
                              reference={{ id: "jJHjSn" }}
                              style={{
                                minWidth: "25px",
                                height: "15px",
                              }}
                            />
                          </span>
                        </p>
                      </div>

                      <div className="columnRight">
                        <NativeObject
                          app={app}
                          key="GgVZbvQ"
                          reference={{ id: "GgVZbvQ" }}
                          style={{
                            width: "29px",
                            height: "25px",
                          }}
                        />
                      </div>
                    </div>

                    <div className="container-kpiCard-mobile">
                      <KpiCardOverview
                        app={app}
                        KPITitle={"ST Aero CX"}
                        valueId={"XMnGuq"}
                        goalValueId={"XMnGuq"}
                        percentageId={"XMnGuq"}
                        hasProgressBar={true}
                        fullView
                      />

                      <KpiCardOverview
                        app={app}
                        KPITitle={"ST LED CX"}
                        valueId={"UKeJJ"}
                        goalValueId={"UKeJJ"}
                        percentageId={"UKeJJ"}
                        hasProgressBar={true}
                        fullView
                      />
                    </div>

                    <div className="container-kpiCard-mobile">
                      <KpiCardOverview
                        app={app}
                        KPITitle={"ST PIR CX"}
                        valueId={"XPbTC"}
                        goalValueId={"XPbTC"}
                        percentageId={"XPbTC"}
                        hasProgressBar={true}
                        fullView
                      />

                      <KpiCardOverview
                        app={app}
                        KPITitle={"CLC AERO"}
                        valueId={"gwUrv"}
                        goalValueId={"gwUrv"}
                        percentageId={"gwUrv"}
                        hasProgressBar={true}
                        fullView
                      />
                    </div>

                    <div className="container-kpiCard-mobile">
                      <KpiCardOverview
                        app={app}
                        KPITitle={"CLC LED"}
                        valueId={"KZRnsD"}
                        goalValueId={"KZRnsD"}
                        percentageId={"KZRnsD"}
                        hasProgressBar={true}
                        fullView
                      />

                      <KpiCardOverview
                        app={app}
                        KPITitle={"CLC PIR"}
                        valueId={"gRDtFuE"}
                        goalValueId={"gRDtFuE"}
                        percentageId={"gRDtFuE"}
                        hasProgressBar={true}
                        fullView
                      />
                    </div>
                  </div>

                  <NativeObject
                    app={app}
                    key="njLAhFT"
                    reference={{ id: "njLAhFT" }}
                    style={{
                      height: "calc(100vh - 200px)",
                      marginBottom: "10px",
                    }}
                  />
                </Card>
              </LayoutCardWrapper>
            </Grid>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OverviewMobile.defaultProps = {
  app: null,
  config: {},
};

OverviewMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewMobile;
